import React from "react";
import { useDispatch, useSelector} from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory} from "@fortawesome/free-solid-svg-icons";
import {Comment} from "../../common/Comment"
import RadioOptions from "../../common/RadioGroup";
import { convertToLocalTime, _base64ToArrayBuffer } from "../../../commonFunctions/commonFunctions";
import saveAs from 'file-saver';
import { openModal } from "../../../redux/modal/modalSlice";
import { errorHandler } from "../../../commonFunctions/errorHandler";
import { baseRequest } from "../../../fetch/basicThunk";
import { QUERY_GET_DOWNLOAD_FILE } from "../../../fetch/constantQueries";

function CommentSection(props){
  const dispatch = useDispatch();
  const {loading, comments, changeCaseComment, current,closed,showNewCase, resolution, resolutionOptions, changeResolution} = props;

  async function downloadFile(blobFileGuid) {
        try {
            const data = await baseRequest({param: `${blobFileGuid}`}, dispatch, QUERY_GET_DOWNLOAD_FILE, "GET");
            if (data != "") {
                saveAs(new Blob([ _base64ToArrayBuffer(data.fileBinary)], { type: data.contentType }), data.fileName);
            } else {
                dispatch(openModal({ type: "warning", message:"Erro ao baixar arquivo."}));
            }  
        } catch (error) {
            dispatch(openModal(errorHandler(error)));
        } finally{
        }
    }

    return(
        <div style={{display: "flex", flexDirection:"row", padding:"10px 10px 0 10px"}}>
          <div className={"comment-box"}>
            <div style={{height:"20px", display: "flex", alignItems: "flex-start"}}>
              <label htmlFor={"comment-textarea"} style={{flexGrow: 1}}>Comentários</label>
              {/* <RadioOptions options={resolutionOptions} value={resolution} onChange={changeResolution} disabled={closed} loading={loading}/> */}
            </div>
            <textarea disabled={closed} id={"comment-textarea"} className={"comment-area"} onChange={(e)=>changeCaseComment(e.target.value)} value={current}>
            </textarea>
          </div>

        
        <div className={"comment-box"} style={{maxWidth: "586px"}}>
          <div style={{height:"20px", fontWeight:"bold"}}><FontAwesomeIcon icon={faHistory} /> Histórico</div>
              { !showNewCase ?
              <div className="comment-area comment-historic">
                { loading ? null : comments && comments.length < 1 ? <span>Nenhum histórico disponível.</span> :  comments.map((e, i, a)=> <div key={`historic${i}`}>
                <Comment 
                  state={e.state} 
                  agent={e.agent} 
                  date={e.date} 
                  message={e.message}
                  files={e.files}
                  downloadFile={downloadFile}
                  />
            </div>)}
          </div> : <div className="comment-area comment-historic"><span>Nenhum histórico disponível.</span></div>}
        </div>
      </div> 
    )
}

export {CommentSection}